const l = {
  name: "XcodeSwitch",
  dimensions: { width: 33, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 33.4 39.7" style="enable-background:new 0 0 33.4 39.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,26.4c-0.1-0.1-0.1-0.2-0.2-0.4H6.4c-2.8,0-5-2.2-5-5V7c0-2.8,2.2-5,5-5h10c0.5-0.7,1.3-1.3,2.1-1.6l0,0
			c1.2-0.5,2.6-0.5,3.8,0l0,0L26,1.9c1.2,0.5,1.9,1.7,1.9,2.9L28,4.9c0.5,0.2,1.1,0,1.3-0.5l0.4-0.9l1.8,0.8
			c1.5,0.6,2.3,2.4,1.6,3.9l0,0L32,10.9c-0.6,1.5-2.4,2.3-3.9,1.6l0,0l-1.8-0.8l0.4-0.9c0.1-0.3,0.1-0.5,0-0.8l0,0l0,0
			c-0.1-0.2-0.3-0.4-0.5-0.5l-0.7,1.7V21c0,2.8-2.2,5-5,5h-1.2c-0.4,1-1.2,1.7-2.2,2C15.4,28.5,13.8,27.8,13,26.4L13,26.4z
			 M19.3,2.2c-0.4,0.2-0.8,0.5-1.1,0.8c1,0.5,1.8,1.2,2.3,2c0.5,0.7,0.9,1.6,0.9,2.5l0.3,0.1l2.6,1.1L25,6.9l1.8,0.8
			c0.8,0.3,1.3,0.9,1.6,1.6c0.2,0.4,0.2,0.9,0.2,1.3l0.2,0.1c0.5,0.2,1.1,0,1.3-0.5l1.1-2.8l0,0c0.2-0.5,0-1.1-0.5-1.3L30.6,6
			c-0.8,0.9-2.2,1.3-3.4,0.8L25.4,6l0.4-0.9c0.2-0.5,0-1.1-0.5-1.3l-3.7-1.5l0,0C20.8,1.9,20,1.9,19.3,2.2z M18.9,8.7l0.4-0.9
			c0.1-0.3,0.1-0.8-0.4-1.5c-0.5-0.7-1.4-1.4-2.5-1.8L15.4,4l0,0h-9c-1.7,0-3,1.3-3,3v14c0,1.7,1.3,3,3,3h6.3
			c0.1-0.3,0.1-0.5,0.3-0.8l2.5-5.2H11l-2.3,3.5l-1.7-1.1L8.7,18H7.4v-2h2.5l2.3-3.6L9.1,7.5l1.7-1.1l2.7,4.1l2.7-4.1l1.7,1.1
			l-3.2,4.9l2,3.1l3.1-6.5L18.9,8.7z M14.5,16l-1.1-1.7L12.3,16H14.5z M23.4,14.1L19.9,24h0.5c1.7,0,3-1.3,3-3V14.1z M21.6,9.8
			l-6.9,14.3c-0.2,0.4-0.2,0.9,0,1.3c0.3,0.6,1,0.9,1.7,0.7l0,0c0.4-0.1,0.8-0.5,1-0.9l5.2-14.9L21.6,9.8z"/>
		<path class="st0" d="M5.7,28.3l1.4,1.4L3.8,33h8.6v2H3.8l3.3,3.3l-1.4,1.4L0,34L5.7,28.3z"/>
		<path class="st0" d="M21.1,28.3l5.7,5.7l-5.7,5.7l-1.4-1.4L23,35h-8.6v-2H23l-3.3-3.3L21.1,28.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as XcodeSwitch
};
